import { IServiceChallenges, ItemType } from "adapters/challenges.adapter";


const DATA: IServiceChallenges[] = [
    {
        userId: 0,
        idChallenge: 49,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¡Bienvenido a tu curso sobre créditos!",
                url: "https://player.vimeo.com/video/994226679?h=848b3c3f06&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "",
                description: "Descubre todo lo que necesitas saber para obtener y gestionar un crédito exitosamente.",
                completed: false
            }
        ],
        description: ""
    },
    {
        userId: 0,
        idChallenge: 50,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¿Qué debo tener presente al solicitar de un crédito?",
                url: "https://player.vimeo.com/video/988412906?h=a043a48155&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "https://images.ctfassets.net/gkhyeghj07ak/4gnhu9XfNs5X3BpqZnV93v/2d95c268b0d6cc54181b5cbfbc7c71b0/solicitud.jpg",
                description: "Al momento de solicitar un crédito es vital que tengas presente los siguientes puntos:",
                completed: false
            }
        ],
        description: ""
    },
    {
        userId: 0,
        idChallenge: 51,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¿Qué características y costos tiene un crédito?",
                url: "https://player.vimeo.com/video/988412977?h=60b955d02d&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "https://images.ctfassets.net/gkhyeghj07ak/7a0ZpixgaSoL04CgmuZntL/2f9eb801be48397bc3593953d447959b/caracteristicas1.jpg",
                description: "Empecemos a conversar sobre algunos conceptos que hacen parte de tu crédito",
                completed: false
            }
        ],
        description: ""
    },
    {
        userId: 0,
        idChallenge: 52,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¿Qué características y costos tiene un crédito?",
                url: "https://player.vimeo.com/video/988413058?h=3cbeaf5bd4&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "https://images.ctfassets.net/gkhyeghj07ak/5UT4Y5dgfaalz9Va5wXuN6/acc539fd08bdc35c4496e73e5ef086bd/caracteristicas2.jpg",
                description: "Existen otros elementos de tu crédito que debes tener presente cuando consigues un crédito.",
                completed: false
            }
        ],
        description: ""
    },
    {
        userId: 392,
        idChallenge: 53,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¿Cómo debo administrar mi crédito?",
                url: "https://player.vimeo.com/video/988413123?h=20dbd58dc0&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "https://images.ctfassets.net/gkhyeghj07ak/1JLqaoD9B4P1LSsTKFw3Ic/8610ef4802b3e93840e60000b44ecd65/administra.jpg",
                description: "Es importante enteder que al tener un crédito se adquiere una responsabilidad.",
                completed: false
            }
        ],
        description: ""
    },
    {
        userId: 0,
        idChallenge: 54,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¿Qué pasa si no pago mi crédito?",
                url: "https://player.vimeo.com/video/988413171?h=4692cb44cc&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "https://images.ctfassets.net/gkhyeghj07ak/3zZcHrlFGPz4qSJiGhsbal/5db03bf64e5d180a05008c896400ce66/nopago.jpg",
                description: "Por no pagar en el tiempo acordado puedes tener cobros adicionales.",
                completed: false
            }
        ],
        description: ""
    },
    {
        userId: 0,
        idChallenge: 55,
        subChallengeDTO: [
            {
                type: ItemType.Video,
                title: "¿Dónde puedo consultar el estado de mi crédito?",
                url: "https://player.vimeo.com/video/988413220?h=bb37827717&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                urlImage: "https://images.ctfassets.net/gkhyeghj07ak/7hqvamOpgNVcpui8l4ZyX1/61bc8a7a3658d3d2f83e7610753d3e95/consulta.jpg",
                description: "Conoce algunas herramientas que te ayudarán a administrar tu crédito de forma efectiva.",
                completed: false
            }
        ],
        description: ""
    }
]

const GET_CHALLENGES_MOCK = {
    data: {
        status: 200,
        userMessage: "Consulta exitosa.",
        developerMessage: "Consulta exitosa.",
        statusName: "OK",
        data: DATA
    }
};


const GET_QUESTIONS_MOCK = {
    data: {
        status: 200,
        userMessage: "Consulta exitosa.",
        developerMessage: "Consulta exitosa.",
        statusName: "OK",
        data: [
            {
                id: 15,
                name: "Curso Oncredit",
                questions: [
                    {
                        id: 185,
                        name: "¿Qué requisitos debo cumplir para que me aprueben el crédito? ",
                        type: {
                            id: 2,
                            name: "radio"
                        },
                        horizontal: false,
                        required: true,
                        options: [
                            {
                                id: 1301,
                                name: "Elaborar un presupuesto",
                                correctOption: false
                            },
                            {
                                id: 1302,
                                name: "Ser bachiller, tener ahorros, manejar Excel",
                                correctOption: false
                            },
                            {
                                id: 1303,
                                name: "Ser mayor de edad, estar al día en otros créditos, tener buen historial crediticio",
                                correctOption: true
                            },
                            {
                                id: 1304,
                                name: "Elaborar un presupuesto, ser bachiller, estar al día en otros créditos",
                                correctOption: false
                            }
                        ],
                        purpose: 15
                    },
                    {
                        id: 186,
                        name: "¿Qué son los intereses corrientes?",
                        type: {
                            id: 2,
                            name: "radio"
                        },
                        horizontal: true,
                        required: true,
                        options: [
                            {
                                id: 1305,
                                name: "Son el costo que tiene el dinero que me prestaron.",
                                correctOption: true
                            },
                            {
                                id: 1306,
                                name: "Es el tiempo que tengo para pagar el crédito.",
                                correctOption: false
                            },
                            {
                                id: 1307,
                                name: "Es el valor de la factura de la luz.",
                                correctOption: false
                            },
                            {
                                id: 1308,
                                name: " Es lo que paga el crédito en caso de que fallezca.",
                                correctOption: false
                            }
                        ],
                        purpose: 15
                    },
                    {
                        id: 187,
                        name: "¿Qué es la cuota de manejo?",
                        type: {
                            id: 2,
                            name: "radio"
                        },
                        horizontal: true,
                        required: true,
                        options: [
                            {
                                id: 1309,
                                name: "Es el valor de la licencia de conducción.",
                                correctOption: false
                            },
                            {
                                id: 1310,
                                name: "Es el costo que se paga por tener cupo disponible.",
                                correctOption: false
                            },
                            {
                                id: 1311,
                                name: "Es el costo del mantenimiento y la administración de mi préstamo. ",
                                correctOption: true
                            },
                            {
                                id: 1312,
                                name: "Es un porcentaje de reembolso sobre el préstamo.",
                                correctOption: false
                            }
                        ],
                        purpose: 15
                    },
                    {
                        id: 188,
                        name: "¿Cómo puedo disminuir los intereses de mi deuda?",
                        type: {
                            id: 2,
                            name: "radio"
                        },
                        horizontal: true,
                        required: true,
                        options: [
                            {
                                id: 1313,
                                name: "Haciendo un calendario de pagos.",
                                correctOption: false
                            },
                            {
                                id: 1314,
                                name: "Realizar abonos parciales y abonos extras. ",
                                correctOption: true
                            },
                            {
                                id: 1315,
                                name: " Llevando un registro de mis ingresos y gastos. ",
                                correctOption: false
                            },
                            {
                                id: 1316,
                                name: " Todas las anteriores ",
                                correctOption: false
                            }
                        ],
                        purpose: 15
                    },
                    {
                        id: 189,
                        name: "¿Qué son los intereses de mora?",
                        type: {
                            id: 2,
                            name: "radio"
                        },
                        horizontal: true,
                        required: true,
                        options: [
                            {
                                id: 1317,
                                name: " Es la subida de los precios durante un periodo de tiempo.",
                                correctOption: false
                            },
                            {
                                id: 1318,
                                name: " Es cuando tengo un endeudamiento excesivo.",
                                correctOption: false
                            },
                            {
                                id: 1319,
                                name: " Es el costo del mantenimiento de mi préstamo.",
                                correctOption: false
                            },
                            {
                                id: 1320,
                                name: "Es dinero extra que debo asumir por no pagar a tiempo. ",
                                correctOption: true
                            }
                        ],
                        purpose: 15
                    },
                    {
                        id: 190,
                        name: "¿Dónde puedes consultar el estado de tu cuenta?",
                        type: {
                            id: 2,
                            name: "radio"
                        },
                        horizontal: true,
                        required: true,
                        options: [
                            {
                                id: 1321,
                                name: "En el instagram de Comfama Servicios financieros",
                                correctOption: false
                            },
                            {
                                id: 1322,
                                name: "Me llega información a Whatsapp. ",
                                correctOption: false
                            },
                            {
                                id: 1323,
                                name: " En el extracto mensual que llega a mi correo y en la página web de Comfama. ",
                                correctOption: true
                            },
                            {
                                id: 1324,
                                name: "En la página de datacredito. ",
                                correctOption: false
                            }
                        ],
                        purpose: 15
                    }
                ],
                active: true
            }
        ]
    }

}

export { GET_CHALLENGES_MOCK, GET_QUESTIONS_MOCK };

